import {useEffect, useState} from 'react';
import {postAuthEmailGuardSend} from 'api/auth';
import {alertByError} from 'utils/alerts';

function useSendEmailGuard(session) {
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const {two_factor_session_id} = session || {};

  useEffect(() => {
    sendEmailGuard();

    return () => {
      setIsSent(false);
      setIsSending(false);
    };
  }, []);

  async function sendEmailGuard() {
    setIsSending(true);
    try {
      await postAuthEmailGuardSend({two_factor_session_id});

      setIsSending(false);
    } catch (e) {
      setIsSending(false);
      await alertByError(e);
    }
  }

  async function resendEmailGuard() {
    await sendEmailGuard();
    setIsSent(true);
  }

  return {
    isSent,
    isSending,
    onSendEmailGuard: sendEmailGuard,
    onResendEmailGuard: resendEmailGuard,
  };
}

export default useSendEmailGuard;
